export default __webpack_public_path__ + "static/media/liz3.cf34389c.jpeg";